import { combineReducers } from "redux";
import session from "./session";
import ui from "./ui";
import emailAccounts from "./emailaccounts";
import resources from "./resources";
import ownershipCheck from "./ownershipcheck";
import forms3 from "./forms3";
import orders from "./orders";
import apitoken from "./apitoken";

export default combineReducers({
  session,
  ui,
  emailAccounts,
  forms3,
  resources,
  ownershipCheck,
  orders,
  apitoken
});
